import { useEffect } from 'react';
import styled from '@emotion/styled';

import { useNavigate } from 'react-router-dom';

import { Grid, Card, CardContent, CardHeader, Divider, useTheme, CardActionArea, Button } from '@mui/material';

import AddRounded from '@mui/icons-material/AddRounded';
import ShoppingCartCheckoutRoundedIcon from '@mui/icons-material/ShoppingCartCheckoutRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import { BasicFlex, FullDivider } from '../../../utils/Common';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import useIsMobile from '../../../hooks/useIsMobile';

// contexts
import { useFormikContext } from 'formik';
import { useDialogForm } from '../../../contexts/DialogForm';
import { useFormData } from '../../../contexts/FormData';

import Field from '../../../utils/FormikFields/Field';

import { formatCurrency, formatGenericDate } from '../../../utils/util';

import AddPayment from './AddPayment';

import { useUrlParams } from '../../../contexts/UrlParams';

import BalanceDisplay from '../../Invoices/Components/BalanceDisplay';

const SummaryCard = styled(Card)`
  width: 100%;
`

const SummaryTitle = styled(CardBlockHeader)`
  margin: 1.5rem 0;
`

const BalanceTotal = styled.div`
  min-width: fit-content;
  flex-grow: 1;
`

const BalanceAmount = styled.div`
  font-weight: ${props => props.$total ? '600' : '500'};
  font-size: ${props => props.$total ? '1.6rem' : '1.4rem'};
  color: ${props => props.$balance ? props.theme.colors.error : "inherit"};
`

const SwitchContainer = styled.div`
  margin-top: 1.5rem;
  padding-left: .5rem;
`

const BalanceLine = ({title, description, amount, total = false, balance = false}) => {
  let check_red = balance && +amount > 0 ? true : false
  const { isNotDesktop } = useIsMobile();
  return (
    <BasicFlex dir="row" justify="space-between" align="center">
      <BalanceTotal>{title}</BalanceTotal>
      <BasicFlex width="20rem">
        <div>{!isNotDesktop ? description : ""}</div>
        <BalanceAmount $total={total} $balance={check_red}>{formatCurrency(amount || 0)}</BalanceAmount>
      </BasicFlex>
    </BasicFlex>
  )
}


const getAppliedStatus = (past_balance, applied_payments_total) => {
  let status, amount = applied_payments_total;
  if (past_balance <= 0) {
    amount = 0;
  } else {
    if (applied_payments_total <= 0) {
      amount = 0;
    }
  }
  status = `Applied ${formatCurrency(amount)}`;
  return { status, amount };
}

const calculateAdjustments = (adjustments, total) => {
//  let selected = adjustments?.filter(el => el.selected === true) || [];
 let adjustmentTotal = 0;
 adjustments.forEach(el => {
  let adjustmentRate = el.rate_type === "percentage" ? (total * (el.rate / 100)) : el.rate;
   if (el.item_type === "charge") {
     adjustmentTotal += adjustmentRate;
   } else {
     adjustmentTotal -= adjustmentRate;
   }
 });
 return adjustmentTotal;
}


const Sidebar = () => {
  const { values, submitForm } = useFormikContext() || {};
  const { formValues } = useFormData() || {};

  // console.log(values, "values");

  const { isEdit } = useUrlParams() || {};

  const { handleClose } = useDialogForm() || {};

  const theme = useTheme();

  const navigate = useNavigate();

  let paymentStage = !!values?.bill_id

  let vendor = formValues?.vendor || {};

  let past_balance = vendor?.balance || 0;

  console.log(past_balance, "past_balance", values?.total);

  past_balance = past_balance - (values?.total || 0);


  let wigs_total = values?.wigs?.reduce((total, wig) => total + +wig.rate, 0);
  let repairs_total = values?.repairs?.reduce((total, repair) => total + +repair.rate, 0);
  let subtotal = wigs_total + repairs_total;
  console.log(values.adjustments, "values.adjustments")
  let adjustments_total = calculateAdjustments(values?.adjustments, subtotal);
  let total = subtotal + adjustments_total;

  let new_payments_total = formValues?.new_payments?.reduce((acc, el) => acc + +el?.amount, 0) || 0;

  let available_credit = past_balance < 0 ? Math.abs(past_balance) : 0;

  let total_payments = values.apply_credit && paymentStage ? +available_credit + +new_payments_total : +new_payments_total;

  if (isEdit) {
    total_payments += +values?.total_paid
  }

  let applied_payments_total = formValues?.applied_payments?.filter(el => el?.selected)?.reduce((acc, el) => acc + +el?.amount, 0) || 0;

  let { status: applied_status, amount: applied_amount } = getAppliedStatus(past_balance, applied_payments_total);

  let grand_total = total + +past_balance;

  let total_items = values?.wigs?.length

  let vendor_balance = total - (values?.total_paid || 0);

  const vendorDetails = [
    { header: "Vendor", info: formValues.vendor_name, grow: true },
    { header: "Opening Balance", info: <BalanceDisplay balance={past_balance} />, grow: true },
  ]

  useEffect(() => {
    if (values?.finished_processing && values?.bill_id && !isEdit) {
      navigate(`/bills/edit/${values.bill_id}`);
    }
  }, [values?.finished_processing])
  
  return (
    <BasicFlex dir="column" gap="2rem">

      <SummaryCard variant='outlined'>
        <CardHeader title="Vendor Information" />
        <CardContent >

          <CardBlockContainer>
            <CardBlockHeader>Vendor Details</CardBlockHeader>
            {vendorDetails.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
          </CardBlockContainer>
        </CardContent>
      </SummaryCard>

      {/* {paymentStage ? <SummaryCard variant='outlined'>
        <CardHeader title="Payments" />
        <CardContent >
          <BasicFlex dir="column" gap="1.5rem">
            <BalanceLine title="Available Credit" description="" amount={available_credit} />
            <BalanceLine title="New Payments" description={formValues?.new_payments?.length} amount={new_payments_total} />
            <BalanceLine title="Total Amount" description="" amount={total_payments} total={true} />
          </BasicFlex>
          <Divider sx={{margin: "1.5rem 0"}} />
          <SwitchContainer>
            <Field formFieldType="switch" type="checkbox" name="apply_credit" label="Use Available Credit" color="secondary" />
          </SwitchContainer>
        </CardContent>
        <Divider />
        <CardActionArea sx={{padding: "1rem"}}>
          <AddPayment />
        </CardActionArea>
      </SummaryCard> : null } */}

      <SummaryCard variant='outlined'>
        <CardHeader title="Bill Summary" />
        <CardContent >
          <BasicFlex dir="column" gap="1.5rem">

            {values?.wigs?.length ? <BalanceLine title="Wigs Total" description={values?.wigs?.length ? `${values?.wigs?.length} Wigs` : ""} amount={wigs_total} /> : null}

            {values?.repairs?.length ? <BalanceLine title="Repairs Total" description={values?.repairs?.length ? `${values?.repairs?.length} Repairs` : ""} amount={repairs_total} /> : null}

            <BalanceLine title="Sub Total" description={total_items ? `${total_items} Items` : ""} amount={subtotal} />

            <BalanceLine title="Charges & Discounts" description={values?.adjustments?.length ? `${values?.adjustments?.length} Adjustments` : ""} amount={adjustments_total} />

            <BalanceLine title="Total" amount={total} />
            <BalanceLine title="Invoice Balance" amount={vendor_balance} />
            
            <Divider sx={{width: "100%"}} />
            <BalanceLine title="Opening Balance" description={applied_status} amount={past_balance} muted />
            <BalanceLine title="New Payments" amount={+new_payments_total} muted />
            <BasicFlex>
              <div>Vendor Balance</div>
              <BalanceDisplay balance={grand_total - +new_payments_total} />
            </BasicFlex>
          </BasicFlex>
        </CardContent>
         <Divider />
        <CardActionArea sx={{padding: "1rem", display: "flex", flexDirection: "column", gap: "1rem"}}>
          {!paymentStage ? <Button fullWidth color="primary" variant="contained" onClick={(e) => {
            e.stopPropagation();
            submitForm()
            // navigate(`/invoices/edit/${values?.invoice_id}`);
          }} size="large" startIcon={<ArrowForwardRoundedIcon />}>Save & Continue to Payment</Button> : null}
          
          {!paymentStage ? <Button fullWidth color="primary" variant="outlined" onClick={(e) => {
            e.stopPropagation();
            submitForm()
            navigate(`/bills`);
          }} size="large" startIcon={<ShoppingCartCheckoutRoundedIcon />}>Save Bill</Button> : null}

          {paymentStage ?<Button fullWidth color="primary" variant="contained" onClick={(e) => {
            e.stopPropagation();
            submitForm()
            navigate(`/bills`);
          }} size="large" startIcon={<ShoppingCartCheckoutRoundedIcon />}>Save Bill</Button> : null}
        </CardActionArea>
      </SummaryCard>

    </ BasicFlex>
  )
};

export default Sidebar;